import { BookOpen } from "lucide-react";

const Blog = () => {
  return (
    <div className="pt-24 pb-20 bg-gray-50 min-h-screen flex items-center justify-center">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center p-3 bg-orange-100 rounded-full mb-6">
             <BookOpen className="h-8 w-8 text-orange-600" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">Kennisbank & Nieuws</h1>
          <p className="text-xl text-gray-600">
            Blijf op de hoogte van de laatste ontwikkelingen, handige tips en eerlijk advies over klimaatbeheersing en verduurzaming.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Blog;
